import { ReactNode, useEffect } from 'react';
import {
  serializationOptionsForStringArrayValue,
  serializationOptionsForStringValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';
import { useDebouncedState } from 'utils/hooks/useDebouncedState';
import { FiltersContext } from './FiltersContext';

export const FiltersContextProvider = ({ children }: { children: ReactNode }) => {
  /**
   * Search value
   */
  const [searchParam, setSearchParam] = useSearchParamState({
    searchParamKey: 'search',
    stateValueWhenSearchParamIsUnset: '',
    ...serializationOptionsForStringValue,
  });
  const [debouncedSearch, search, setSearch] = useDebouncedState(searchParam, 300);
  useEffect(() => setSearchParam(search), [debouncedSearch]);

  /**
   * Status
   */
  const [status, setStatus] = useSearchParamState({
    searchParamKey: 'status',
    stateValueWhenSearchParamIsUnset: [],
    ...serializationOptionsForStringArrayValue,
  });

  /**
   * Return values
   */
  const value = {
    debouncedSearch,
    search,
    setSearch,
    setStatus,
    status,
  };

  return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>;
};
